import React from 'react';
import { DEFAULT_ROUTE_DETAILS_ICON } from '../../mockData';
import { IIconTitleAsProps } from '../../../../../sp-types/routeDetailsType';
import { routeDetailsIcons } from '../../routeDetailsUtils';

export const RouteMainTitle: React.FC<IIconTitleAsProps> = ({ title, icon }) => {
  return (
    <div className="flex gap-2 ">
      <img className="h-8 w-8 my-auto" src={(icon && routeDetailsIcons[icon]) || DEFAULT_ROUTE_DETAILS_ICON} />
      <h6 className="border-b  border-red flex-1 self-start pb-1  ">{title}</h6>
    </div>
  );
};
